import { render, staticRenderFns } from "./SignupVerificationPrompt.vue?vue&type=template&id=d3568ebe&scoped=true"
import script from "./SignupVerificationPrompt.vue?vue&type=script&lang=js"
export * from "./SignupVerificationPrompt.vue?vue&type=script&lang=js"
import style0 from "./SignupVerificationPrompt.vue?vue&type=style&index=0&id=d3568ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3568ebe",
  null
  
)

export default component.exports